/**
 * UNCHECKABLE RADIO BUTTON COMPONENT
 *
 * The uncheckable radio button component handles radio buttons
 * that can be unchecked. To make a radio button uncheckable the
 * input needs the "uncheckable" attribute
 */
$(document).ready(function () {

	/**
	 * Initially set the is-checked data attribute for uncheckable radio buttons
	 */
	$("input[type='radio'][uncheckable]").each(function () {
		$(this).data('is-checked', this.checked);
	});

	/**
	 * Manually check the uncheckable radio buttons on a click event
	 */
	$(document).on('click', 'input[type="radio"][uncheckable]', function () {
        window.duo.checkUncheckableRadioButton(this);
	});
});

/**
 * Checks an uncheckable radio button
 * @param {HTMLInputElement} node The node that was checked
 * @param {boolean} shouldCheck Whether to check or uncheck the field
 */
window.duo.checkUncheckableRadioButton = (node, shouldCheck = undefined) => {

    //
	// Store whether the clicked radio button should be eventually checked
	// If the stored data says the button is not checked, it should be checked eventually.
	let check = shouldCheck !== undefined ? shouldCheck : ! $(node).data('is-checked');

	//
	// Uncheck all radio buttons of the same group
	$(`input[name="${ node.name }"]`).each(function (index, input) {
		$(input).data('is-checked', false);
		input.checked = false;
	});

	//
	// Set the checked states for the clicked radio button
	$(node).data('is-checked', check);
	node.checked = check;

    $(node).trigger('change');
}
